(() => {
  const SECTION_SEL = '[data-fps-root]';

  function parseMobileSlides(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : 1.15;
  }

  function initSwiper(root) {
    if (typeof Swiper === 'undefined') return null;

    const el = root.querySelector('.fps__swiper');
    if (!el) return null;

    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    const desktopSlides = parseInt(root.getAttribute('data-slides-desktop') || '4', 10) || 4;
    const mobileSlides = parseMobileSlides(root.getAttribute('data-slides-mobile') || '1.15');
    const prevButtons = root.querySelectorAll('[data-fps-prev]');
    const nextButtons = root.querySelectorAll('[data-fps-next]');
    const paginationEl = root.querySelector('[data-fps-pagination]');

    const swiper = new Swiper(el, {
      slidesPerView: mobileSlides,
      spaceBetween: 15,
      speed: 500,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
          }
        : undefined,
      breakpoints: {
        770: {
          slidesPerView: desktopSlides,
          spaceBetween: 20,
        },
      },
    });

    root._fpsSwiper = swiper;

    if (!root._fpsNavBound) {
      root._fpsNavBound = true;
      root.addEventListener('click', (event) => {
        const prev = event.target.closest('[data-fps-prev]');
        const next = event.target.closest('[data-fps-next]');
        if (!prev && !next) return;
        event.preventDefault();
        const instance = root._fpsSwiper;
        if (!instance) return;
        if (prev) instance.slidePrev();
        if (next) instance.slideNext();
      });
    }

    const syncNav = () => {
      const atStart = swiper.isBeginning;
      const atEnd = swiper.isEnd;
      prevButtons.forEach((btn) => {
        btn.disabled = atStart;
        btn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      });
      nextButtons.forEach((btn) => {
        btn.disabled = atEnd;
        btn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      });
    };

    swiper.on('slideChange', syncNav);
    swiper.on('resize', syncNav);
    syncNav();

    return swiper;
  }

  function initCardSwatches(root) {
    if (root._fpsSwatchesBound) return;
    root._fpsSwatchesBound = true;

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-fps-swatch]');
      if (!swatch || !root.contains(swatch)) return;

      const card = swatch.closest('[data-fps-card]');
      if (!card) return;

      const index = swatch.getAttribute('data-color-index');
      const swatches = card.querySelectorAll('[data-fps-swatch]');
      const images = card.querySelectorAll('[data-fps-image]');
      const buy = card.querySelector('[data-fps-buy]');

      swatches.forEach((s) => s.classList.toggle('is-active', s === swatch));

      images.forEach((img) => {
        const match = img.getAttribute('data-color-index') === index;
        img.classList.toggle('is-active', match);
        if (match) {
          img.removeAttribute('hidden');
        } else {
          img.setAttribute('hidden', '');
        }
      });

      const variantUrl = swatch.getAttribute('data-variant-url');
      if (buy && variantUrl) {
        buy.setAttribute('href', variantUrl);
      }

      const activeImageLink = card.querySelector(
        `[data-fps-image][data-color-index="${index}"] .fps-card__product-link`
      );
      if (activeImageLink && variantUrl) {
        activeImageLink.setAttribute('href', variantUrl);
      }
    });
  }

  function initRoot(root) {
    if (!root) return;
    initSwiper(root);
    initCardSwatches(root);
    root.dataset.fpsReady = 'true';
  }

  function boot() {
    document.querySelectorAll(SECTION_SEL).forEach(initRoot);
  }

  function waitForSwiper(attempt = 0) {
    if (typeof Swiper !== 'undefined') {
      boot();
      return;
    }
    if (attempt > 40) return;
    setTimeout(() => waitForSwiper(attempt + 1), 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => waitForSwiper());
  } else {
    waitForSwiper();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.(SECTION_SEL) || event.target.closest?.(SECTION_SEL);
    if (root) {
      root._fpsSwatchesBound = false;
      root._fpsNavBound = false;
      waitForSwiper();
    }
  });
})();
